/**
 * @desc formSubmit
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.ApprovalRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/approval/formSubmit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
